module.exports = __webpack_public_path__ + "img/hero-banner-01.70f62ded.jpg";